import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneNumberForm = _resolveComponent("PhoneNumberForm")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PhoneNumberForm, {
      msg: _ctx.$t('phoneNumberForm.title')
    }, null, 8, ["msg"])
  ]))
}